var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"preload"},[_c('Plane',{staticStyle:{"position":"absolute","left":"50%","top":"45%","transform":"translate(-50%, -50%)"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }